/**
 * The reservation, supplied once and read anywhere in the workspace.
 *
 * Every screen used to import the RESERVATION constant directly, which made the
 * placeholder impossible to replace without touching each of them. A context
 * keeps those call sites as they were — one identifier, same shape — while the
 * value behind it now comes from the DMS.
 *
 * Outside a provider it yields the placeholder, so a screen rendered on its own
 * (a design review, a test) still has something sensible to draw.
 */

import React, { createContext, useContext, ReactNode } from "react";
import { Reservation, RESERVATION } from "./reservation";

const ReservationContext = createContext<Reservation>(RESERVATION);

export const ReservationProvider = ({
  reservation,
  children,
}: {
  reservation: Reservation;
  children: ReactNode;
}) => (
  <ReservationContext.Provider value={reservation}>
    {children}
  </ReservationContext.Provider>
);

export const useReservation = (): Reservation => useContext(ReservationContext);
